import { Box } from '@mui/material';

interface LogoCompaniesProps {
  url: string;
  maxWidth: string;
  width: string;
  boxWidth: string;
  height: string;
  justifyContent: string;
}

export const LogoCompanies = ({
  url,
  maxWidth,
  width,
  boxWidth,
  height,
  justifyContent,
}: LogoCompaniesProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent,
        alignItems: 'center',
        width: boxWidth,
        alignContent: 'center',
        height: '100%',
      }}
    >
      <img
        src={url}
        alt="Logo Empresa"
        style={{
          maxWidth,
          width,
          height,
          objectFit: 'contain',
          objectPosition: 'center center',
          mixBlendMode: 'multiply',
        }}
      />
    </Box>
  );
};
